import React from "react"
import classnames from "classnames"
import { Link } from "gatsby"
import Spinner, { SpinnerVariants } from "./spinner"
import { motion } from "framer-motion"

export const ButtonVariants = Object.freeze({
  CallToAction: "bg-white text-black hover:bg-gray-100 focus:bg-gray-100",
  Default: "bg-primary text-white hover:bg-opacity-90 focus:bg-opacity-90",
  Gray: "bg-gray-200 text-black hover:bg-gray-100 focus:bg-gray-100",
})

export default function Button({
  type,
  to,
  href,
  className,
  onClick,
  children,
  variant,
  block,
  disabled,
  outlined,
  loading,
  component,
  ...props
}) {
  let tag = motion.button
  if (!!to) tag = Link
  if (!!href) tag = motion.a
  if (!!component) tag = component

  return React.createElement(
    tag,
    {
      type,
      to,
      href,
      onClick: disabled ? null : onClick,
      className: classnames(
        "inline-flex items-center justify-center rounded font-body text-body-14  lg:text-base py-4 px-7.5 select-none transition duration-200 ease-out focus:outline-none",
        variant,
        block && "w-full",
        !disabled && "cursor-pointer",
        disabled && "opacity-50 cursor-not-allowed",
        outlined && "border border-black focus:outline-none",
        outlined && !disabled && "hover:border-gray-800 focus:border-gray-800",
        className
      ),
      ...props,
    },
    <span className="inline-flex flex-row items-center">
      {loading ? (
        <Spinner
          className="mr-2"
          variant={
            variant !== ButtonVariants.CallToAction
              ? SpinnerVariants.White
              : SpinnerVariants.Primary
          }
        />
      ) : null}
      {children}
    </span>
  )
}

Button.defaultProps = {
  type: "button",
  to: undefined,
  href: undefined,
  variant: ButtonVariants.Default,
  block: false,
  disabled: false,
  outlined: false,
  loading: false,
}

export function ButtonIcon({ icon: Icon, className, iconClassName, ...props }) {
  return (
    <span className={classnames("w-5 h-5 mr-2.5", className)} {...props}>
      <Icon className={classnames("w-full h-full", iconClassName)} />
    </span>
  )
}
